
const state = {
    currentStore: localStorage.getItem('current_store')
}

const mutations = {
    CHANGE_CURRENT_STORE(state, value){
        state.currentStore = value
        localStorage.setItem('current_store', value)
    }
}

const actions = {
    changeStoreAction({ commit }, payload){
        commit('CHANGE_CURRENT_STORE', JSON.stringify(payload))
        try {
            localStorage.removeItem('relacionDespacho')
            localStorage.removeItem('packingList')
        } catch (error) {
            
        }
    }
}

const getters = {
    currentStoreUser(state){
        const currentStore = JSON.parse(state.currentStore)
        return currentStore.name
    },
    idCurrentStore(state){
        const currentStore = JSON.parse(state.currentStore)
        return currentStore.number
    }
}

export {
    state,
    mutations,
    actions,
    getters
}